
import {Vue, Component, Prop} from 'vue-property-decorator';
import GiftIcon from '@/components/Icons/GiftIcon.vue';
@Component({
    components:{
        GiftIcon
    }
})
export default class GiftInfoModal extends Vue {
  @Prop({type: String, default: ''}) public readonly title!: string;
  @Prop({type: String, default: ''}) public readonly link!: string;
}
